export const translations = {
  en: {
    // Navigation
    home: 'Home',
    plans: 'Plans',
    features: 'Features',
    coverage: 'Coverage',
    support: 'Support',
    partners: 'Partners',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    dashboard: 'Dashboard',
    getStarted: 'Get Started',

    // Hero Section
    heroTitle: 'eSIM Myanmar Entertainment Server',
    heroSubtitle: 'Enterprise eSIM Management Platform serving 50M+ users across ASEAN with 5G, VoLTE, and seamless device transfer capabilities',
    exploreFeatures: 'Explore Features',

    // Stats
    activeUsers: 'Active Users',
    uptimeSLA: 'Uptime SLA',
    countries: 'Countries',
    support24_7: 'Support',

    // Features
    featuresTitle: 'Advanced eSIM Features',
    featuresSubtitle: 'Industry-leading eSIM technology with enterprise-grade security and reliability',

    // Entertainment
    entertainmentTitle: 'Entertainment Services',
    entertainmentSubtitle: 'Premium streaming and entertainment bundled with your eSIM',

    // Contact
    contactInfo: 'Contact Information',
    domain: 'esim.com.mm',
    email: 'info@esim.com.mm',
    phone: '09650000172',
    social: '@eSIMMyanmar',

    // Plans
    choosePlan: 'Choose Your Plan',
    planSubtitle: 'Flexible eSIM plans for every need. All plans include 5G, VoLTE, and roaming',
    basicPlan: 'Basic 5G',
    premiumPlan: 'Premium 5G',
    enterprisePlan: 'Enterprise Unlimited',
    perMonth: 'per month',
    days: 'days',
    highSpeedData: 'High-speed data',

    // Auth
    welcomeBack: 'Welcome Back',
    signInAccount: 'Sign in to your eSIM Myanmar account',
    emailAddress: 'Email Address',
    password: 'Password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    signIn: 'Sign In',
    noAccount: "Don't have an account?",
    createAccount: 'Create Account',

    // Register
    createAccountTitle: 'Create Account',
    joinUsers: 'Join 50M+ users on eSIM Myanmar',
    fullName: 'Full Name',
    phoneNumber: 'Phone Number',
    confirmPassword: 'Confirm Password',
    alreadyAccount: 'Already have an account?',

    // Dashboard
    welcome: 'Welcome',
    manageProfiles: 'Manage your eSIM profiles and plans',
    esimProfiles: 'eSIM Profiles',
    activeProfiles: 'Active Profiles',
    dataUsed: 'Data Used',
    myProfiles: 'My eSIM Profiles',
    createNewESIM: 'Create New eSIM',
    noProfiles: 'No eSIM profiles yet',
    createFirst: 'Create Your First eSIM'
  },
  mm: {
    // Navigation
    home: 'ပင်မ',
    plans: 'အစီအစဉ်များ',
    features: 'အင်္ဂါရပ်များ',
    coverage: 'ဖုံးလွှမ်းမှု',
    support: 'အကူအညီ',
    partners: 'လုပ်ဖော်ကိုင်ဖက်များ',
    login: 'ဝင်ရောက်ရန်',
    register: 'စာရင်းသွင်းရန်',
    logout: 'ထွက်ရန်',
    dashboard: 'ထိန်းချုပ်မှုပြားခွက်',
    getStarted: 'စတင်ရန်',

    // Hero Section  
    heroTitle: 'eSIM မြန်မာ ဖျော်ဖြေရေး ဆာဗာ',
    heroSubtitle: 'ASEAN တစ်ဝှမ်းရှိ အသုံးပြုသူ ၅၀ သန်းကျော်အား 5G, VoLTE နှင့် ချောမွေ့သော စက်ပစ္စည်းလွှဲပြောင်းမှု စွမ်းရည်များဖြင့် ဝန်ဆောင်မှုပေးနေသော အင်တာပရိုက်စ် eSIM စီမံခန့်ခွဲမှု ပလက်ဖောင်း',
    exploreFeatures: 'အင်္ဂါရပ်များကို လေ့လာရန်',

    // Stats
    activeUsers: 'လက်ရှိအသုံးပြုသူများ',
    uptimeSLA: 'လုပ်ငန်းဆောင်ရွက်ချိန်',
    countries: 'နိုင်ငံများ',
    support24_7: 'အကူအညီ',

    // Features
    featuresTitle: 'အဆင့်မြင့် eSIM အင်္ဂါရပ်များ',
    featuresSubtitle: 'အင်တာပရိုက်စ်အဆင့် လုံခြုံရေးနှင့် ယုံကြည်စိတ်ချရမှုဖြင့် စက်မှုလုပ်ငန်းတွင် ဦးဆောင်သော eSIM နည်းပညာ',

    // Entertainment
    entertainmentTitle: 'ဖျော်ဖြေရေး ဝန်ဆောင်မှုများ',
    entertainmentSubtitle: 'သင့် eSIM နှင့်အတူ ပါဝင်သော ပရီမီယံ စတရီမင်းနှင့် ဖျော်ဖြေရေး',

    // Contact
    contactInfo: 'ဆက်သွယ်ရန် အချက်အလက်',
    domain: 'esim.com.mm',
    email: 'info@esim.com.mm',
    phone: '09650000172',
    social: '@eSIMMyanmar',

    // Plans
    choosePlan: 'သင့်အစီအစဉ်ကို ရွေးချယ်ပါ',
    planSubtitle: 'လိုအပ်ချက်တိုင်းအတွက် ပြောင်းလွယ်ပြင်လွယ် eSIM အစီအစဉ်များ။ အစီအစဉ်အားလုံးတွင် 5G, VoLTE နှင့် roaming ပါဝင်သည်',
    basicPlan: 'အခြေခံ 5G',
    premiumPlan: 'ပရီမီယံ 5G',
    enterprisePlan: 'အင်တာပရိုက်စ် အကန့်အသတ်မရှိ',
    perMonth: 'တစ်လလျှင်',
    days: 'ရက်',
    highSpeedData: 'မြန်နှုန်းမြင့် ဒေတာ',

    // Auth
    welcomeBack: 'ပြန်လည်ကြိုဆိုပါသည်',
    signInAccount: 'သင့် eSIM မြန်မာ အကောင့်သို့ ဝင်ရောက်ပါ',
    emailAddress: 'အီးမေးလ်လိပ်စာ',
    password: 'စကားဝှက်',
    rememberMe: 'ကျွန်ုပ်ကို မှတ်ထားပါ',
    forgotPassword: 'စကားဝှက် မေ့နေပါသလား?',
    signIn: 'ဝင်ရောက်ရန်',
    noAccount: 'အကောင့်မရှိပါသလား?',
    createAccount: 'အကောင့်ဖန်တီးရန်',

    // Register
    createAccountTitle: 'အကောင့်ဖန်တီးရန်',
    joinUsers: 'eSIM မြန်မာတွင် အသုံးပြုသူ ၅၀ သန်းကျော်နှင့် ပူးပေါင်းပါ',
    fullName: 'အမည်အပြည့်အစုံ',
    phoneNumber: 'ဖုန်းနံပါတ်',
    confirmPassword: 'စကားဝှက် အတည်ပြုရန်',
    alreadyAccount: 'အကောင့်ရှိပြီးသားလား?',

    // Dashboard
    welcome: 'ကြိုဆိုပါသည်',
    manageProfiles: 'သင့် eSIM ပရိုဖိုင်များနှင့် အစီအစဉ်များကို စီမံခန့်ခွဲပါ',
    esimProfiles: 'eSIM ပရိုဖိုင်များ',
    activeProfiles: 'လက်ရှိအသုံးပြု ပရိုဖိုင်များ',
    dataUsed: 'အသုံးပြုထားသော ဒေတာ',
    myProfiles: 'ကျွန်ုပ်၏ eSIM ပရိုဖိုင်များ',
    createNewESIM: 'eSIM အသစ်ဖန်တီးရန်',
    noProfiles: 'eSIM ပရိုဖိုင်များ မရှိသေးပါ',
    createFirst: 'သင့်ပထမဆုံး eSIM ကို ဖန်တီးပါ'
  }
};

export default translations;